<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <search v-on:download="onDownload" v-on:searching="onSearch"></search>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="invoices"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
                v-model="complex.selected"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">{{ props.item.controlNumber }}</td>
                  <td class="text-sm-left">{{ props.item.invoiceNumber }}</td>
                  <td class="text-sm-left">
                    <vue-numeric
                      class="text-sm-left"
                      disabled
                      readonly
                      separator=","
                      v-bind:minus="false"
                      v-bind:precision="2"
                      v-model="props.item.cif"
                    ></vue-numeric>
                  </td>
                  <td class="text-sm-left">{{ props.item.packageNumber }}</td>

                  <td class="text-sm-left">
                    {{ props.item.dist_invoices.name }}
                  </td>
                  <td class="text-sm-left">{{ props.item.orderNumber }}</td>
                  <td class="text-sm-left">
                    {{ props.item.lab_invoices.name }}
                  </td>

                  <td class="text-sm-left">
                    {{ dateFormat(props.item.receivedDate) }}
                  </td>
                  <td class="text-sm-left">
                    <v-btn
                      :to="`/facturas/editar/${props.item.id}`"
                      color="info"
                      flat
                      icon
                      v-if="props.item.fdApproved === null"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      @click="
                        invoiceDelete.modal = true
                        invoiceDelete.id = props.item.id
                      "
                      color="error"
                      flat
                      icon
                      v-if="isAdminUser"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              :total-visible="7"
              @input="asyncPagination"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>

    <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
      <message
        :key="dialog.key"
        :options="dialog"
        v-on:close="dialog.show = false"
      ></message>
    </v-dialog>

    <v-dialog max-width="400" v-model="invoiceDelete.modal">
      <v-card>
        <v-card-title class="headline">Eliminar Factura</v-card-title>

        <v-card-text>
          <p>
            Estas a punto de remover una factura permanentemente, este proceso
            no puede ser revertido.
          </p>
          <p>Estas Seguro?</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="invoiceDelete.modal = false" color="primary" text
            >Cancelar</v-btn
          >
          <v-btn @click="deleteInvoice" color="error" text>OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from './../dialog/DialogLoading'
import message from './../dialog/Message'
import { dateFormat } from '@/helpers/TransitHelper'
import search from './../transit/Search.vue'
import SessionHelper from '@/helpers/SessionHelper'
import AppACL from '@/plugins/acl/ACL'

export default {
  components: {
    loading,
    search,
    message,
  },
  data() {
    return {
      loading: true,
      invoiceDelete: {
        modal: false,
        id: null,
      },
      dialog: {
        show: null,
        key: 0,
      },
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      complex: {
        headers: [
          {
            text: '# Control',
            value: 'controlNumber',
            align: 'left',
            sortable: false,
          },
          {
            text: '# Factura',
            value: 'invoiceNumber',
            align: 'left',
            sortable: false,
          },
          {
            text: '# CIF',
            value: 'cif',
            align: 'left',
            sortable: false,
          },
          {
            text: '# Bulto',
            value: 'packageNumber',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Distribuidor',
            value: 'dist_invoices.name',
            align: 'left',
            sortable: false,
          },
          {
            text: '# Pedido',
            value: 'orderNumber',
            align: 'left',
            sortable: false,
          },

          {
            text: 'Laboratorio',
            value: 'lab_invoices.name',
            align: 'left',
            sortable: false,
          },

          {
            text: 'Fecha',
            value: 'receivedDate',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Acciones',
            sortable: false,
            align: 'left',
          },
        ],
      },
    }
  },
  created() {
    this.asyncPagination()
  },
  computed: {
    ...mapState({
      invoices: state => state.invoices.all,
    }),
    isAdminUser() {
      return (
        SessionHelper.role === AppACL.ROLE.ADM ||
        SessionHelper.role === AppACL.ROLE.GEM
      )
    },
  },
  methods: {
    dateFormat,
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true
      const filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        ...this.pagination.search,
      }
      return new Promise(resolve => {
        this.$store.dispatch('invoices/getAll', filter).then(response => {
          this.helperPaginate(response)
          return resolve()
        })
      })
    },
    onSearch(params) {
      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
    deleteInvoice() {
      this.invoiceDelete.modal = false
      this.loading = true

      this.$store
        .dispatch('invoices/delete', { invoiceID: this.invoiceDelete.id })
        .then(response => {
          if (response.data == 0) {
            this.loading = false
            this.dialog = {
              message:
                'La factura no pudo ser eliminada, contacte al soporte tecnico',
              show: true,
              color: 'red',
              key: this.dialog.key + 1,
            }
          } else {
            this.asyncPagination()
          }
        })
    },
  },
}
</script>
